import React from 'react'
import * as Icons from '@mui/icons-material';

function Save({ widgetProps, widgetStyle }) {
    console.log(widgetStyle);
    function DynamicIcon({ iconName }) { const IconComponent = Icons[iconName]; return IconComponent ? <IconComponent sx={[widgetStyle ?? {}, {minHeight: '20px'}]} /> : null; }
    return (
        <DynamicIcon iconName={widgetProps.iconName ? widgetProps.iconName : 'Favorite'} />
    );
}

export default React.memo(Save);